import { render, staticRenderFns } from "./NewsBdo.vue?vue&type=template&id=4845b133&scoped=true&"
import script from "./NewsBdo.vue?vue&type=script&lang=js&"
export * from "./NewsBdo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845b133",
  null
  
)

export default component.exports